module.exports = __webpack_public_path__ + "assets/e6cf7c6ec7c2d6f670ae9d762604cb0b.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.6.3
 ** module id = 1767
 ** module chunks = 1
 **/